import React from 'react';
import { useCss } from 'app/utils/css';
import { useSetHttpStatus } from 'app/utils/HttpStatusState';
import ForestOwl from 'app/components/svgs/mascot/Forest';
import { useI18n } from 'app/components/localization';
import AlertBox, { AlertVariant } from 'app/components/presentation/alert/AlertBox';

export const UnauthenticatedWarning: React.FC = () => {
  const { t } = useI18n();
  const css = useCss();
  useSetHttpStatus(401);
  return (
    <div
      className={css('container', {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      })}
    >
      <div className={css('asset', { display: 'flex', flexGrow: 1, justifyContent: 'center', marginBottom: '21px' })}>
        <ForestOwl width="60%" />
      </div>

      <AlertBox role="alert" variant={AlertVariant.Warning}>
        {t('auth.login-form.unauthenticated-message')}
      </AlertBox>
    </div>
  );
};

export const FacebookEmailTakenWarning: React.FC = () => {
  const { t } = useI18n();
  return (
    <AlertBox children={t('auth.login-form.facebook-taken-message')} role="alert" variant={AlertVariant.Warning} />
  );
};
